import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import './recommended-callout.scss';
export default function RecommendedCallout({ title, blurb, onPutAway }) {
    const intl = useIntl();
    const titleToUse = title || intl.formatMessage({ id: 'recommended' });
    return (React.createElement("div", { className: "triangle-attachment" },
        React.createElement("div", { className: "container" },
            React.createElement("span", { className: "callout-title" }, titleToUse),
            React.createElement("button", { type: "button", className: "put-away", onClick: onPutAway, "aria-label": "close-popup" },
                React.createElement(FontAwesomeIcon, { icon: faTimes })),
            blurb && React.createElement(RawHTML, { className: "callout-blurb", html: blurb }))));
}
